import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
  effect,
  input,
  booleanAttribute,
} from '@angular/core';
import { SessionService } from '../services/session.service';

@Directive({
  selector: '[isAdmin]',
  standalone: true,
})
export class IsAdminDirective {
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private sessionService = inject(SessionService);
  private hasView = false;

  isAdmin = input(true, { transform: booleanAttribute });

  constructor() {
    effect(() => {
      this.isAdmin();
      this.sessionService.isSessionLoaded();
      this.sessionService.isAdmin();
      this.updateView();
    });
  }

  private updateView(): void {
    const isSessionLoaded = this.sessionService.isSessionLoaded();
    const isUserAdmin = this.sessionService.isAdmin();

    if (!isSessionLoaded) {
      return;
    }

    const shouldShow = !this.isAdmin() || (this.isAdmin() && isUserAdmin);

    if (shouldShow && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!shouldShow && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
